import styled from '@emotion/styled';
import Done from '@material-ui/icons/Done';
import EditLocation from '@material-ui/icons/EditLocation';
import { ClassAttributes, createElement } from 'react';

interface Props {
  done?: boolean;
  className?: string;
}

const EditStatusIcon = ({ done, className }: ClassAttributes<HTMLElement> & Props) => {
  const icon = done ? <Done color="primary" /> : <EditLocation color="secondary" />;

  return <Root className={className}>{icon}</Root>;
};

const Root = styled('div')({ width: 24, height: 24 });

export default EditStatusIcon;
